export default __webpack_public_path__ + "static/media/icon_global_settings.bb40822d.svg";